import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDoubleLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 12",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2046_3043)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M0.776271 6.42675C0.541251 6.19173 0.541251 5.8117 0.776271 5.57918L5.57669 0.776266C5.81171 0.541245 6.19174 0.541245 6.42426 0.776266C6.65678 1.01129 6.65928 1.39132 6.42426 1.62384L2.04888 5.99922L6.42676 10.3771C6.66178 10.6121 6.66178 10.9922 6.42676 11.2247C6.19174 11.4572 5.81171 11.4597 5.57919 11.2247L0.776271 6.42675Z" }), /* @__PURE__ */ _jsx("path", { d: "M5.57626 6.42675C5.34124 6.19173 5.34124 5.8117 5.57626 5.57918L10.3767 0.776266C10.6117 0.541245 10.9917 0.541245 11.2242 0.776266C11.4568 1.01129 11.4593 1.39132 11.2242 1.62384L6.84887 5.99922L11.2267 10.3771C11.4618 10.6121 11.4618 10.9922 11.2267 11.2247C10.9917 11.4572 10.6117 11.4597 10.3792 11.2247L5.57626 6.42675Z" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2046_3043",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgChevronDoubleLeft;
